export default {
    lmsUserIdList: function(state) {
        return state.lmsUserList.map(user => user.userId);
    }
}
